import { Injectable } from '@angular/core';
import { SharedData } from './shared.data';
import {
  MENU_CONFIG, LOCAL_STORAGE_CONSTANTS, MODULE_ID, SESSION_STORAGE_CONSTANTS,
  ROUTER_LINKS_FULL_PATH, COOKIES_CONSTANTS, ROLE_PERMISSION_KEY
} from '@app/config';
import { SessionService, NavigationService, EncriptionService } from '@app/common';
import * as _ from 'lodash';

@Injectable()
// tslint:disable-next-line:component-class-suffix
export class RolePermission {
  menuList = MENU_CONFIG;
  roleData: any;
  rolePermissionArr: any = [];
  rolePermissionsJsonUrlArr = [];
  landingModuleId: any;
  spinnerFlag: Boolean = false;
  disableButtonFlag: Boolean = false;
  /**
  * constructor method is used to initialize members of class
  */
  constructor(
    private sharedData: SharedData,
    private navigationService: NavigationService,
    private sessionService: SessionService,
    private _encriptionService: EncriptionService
  ) { }


  setRolePermissionObj(roleAccessObj: any, compInstance?) {
    const tempRolePermissionArr = [];
    const rolePermissionsArr = roleAccessObj.rolePermissions;
    for (let index = 0; index < rolePermissionsArr.length; index++) {
      tempRolePermissionArr[rolePermissionsArr[index]['moduleId']] = rolePermissionsArr[index];

      if (tempRolePermissionArr[rolePermissionsArr[index]['moduleId']]['uiAccess']) {
        try {
          tempRolePermissionArr[rolePermissionsArr[index]['moduleId']]['uiAccess'] = JSON.parse(tempRolePermissionArr[rolePermissionsArr[index]['moduleId']]['uiAccess']);
        } catch (e) {
          tempRolePermissionArr[rolePermissionsArr[index]['moduleId']]['uiAccess'] = '';
        }
      }
    }
    this.landingModuleId = roleAccessObj['landingModuleId'];
    this.setRolePermissions(tempRolePermissionArr, compInstance);
  }


  setUserInfoDetails(userInfoData) {
    if (userInfoData.authToken) {
      this.sessionService.setSessionItem(COOKIES_CONSTANTS.authToken, userInfoData['authToken']);
      this.sessionService.setCookie(COOKIES_CONSTANTS.authToken, userInfoData['authToken']);
    }
    if (userInfoData.refreshToken) {
      this.sessionService.setSessionItem(COOKIES_CONSTANTS.refreshToken, userInfoData['refreshToken']);
      this.sessionService.setCookie(COOKIES_CONSTANTS.refreshToken, userInfoData['refreshToken']);
    }
    const rolesObj = (userInfoData.rolesDetails.length > 0) ? userInfoData.rolesDetails[0] : {};
    const userInfo = {
      id: userInfoData.id,
      name: userInfoData.i18n.displayName,
      profilePicUrl: userInfoData.profilePicUrl,
      roleId: rolesObj.id,
      rolesArr: userInfoData.roles,
      rolesDetails: userInfoData.rolesDetails,
      roleName: rolesObj.roleName,
      emailId: userInfoData.emailId,
      activationPending: userInfoData.activationPending,
      contractAcceptance: userInfoData.contractAcceptance,
      contractGeneratedPending: userInfoData.contractGeneratedPending,
      showProfileData: userInfoData.showProfileData
    };
    if (userInfoData.rolePermission) {
      userInfo['roleModulePermissions'] = this.encryptData(userInfoData.rolePermission);
    }
    this.sharedData.setUsersInfo(userInfo);
  }

  /*user defined functions/methods after life cycle events-public methods,private methods*/
  /*
* This method is used to encrypt Role Permission data.
*/
  encryptData(data: any) {
    const rolePermissionJSONData = this._encriptionService.setEncryptedData(JSON.stringify(data), ROLE_PERMISSION_KEY);
    return rolePermissionJSONData.toString();
  }


  setUserAccessPermission(userRoleAccessInfoData) {
    if (userRoleAccessInfoData.authToken) {
      this.sessionService.setSessionItem(COOKIES_CONSTANTS.authToken, userRoleAccessInfoData['authToken']);
      this.sessionService.setCookie(COOKIES_CONSTANTS.authToken, userRoleAccessInfoData['authToken']);
    }
    const userInfoData = this.sharedData.getUsersInfo();
    if (userRoleAccessInfoData.rolePermissions) {
      userInfoData['rolePermission'] = userRoleAccessInfoData.rolePermissions;
    }
    this.sharedData.setUsersInfo(userInfoData);
    this.setRolePermissionObj(userRoleAccessInfoData);
  }



  /*method to set the role permissions data*/
  setRolePermissions(rolePermissionsData, compInstance?) {
    try {
      this.sharedData.setRolePermissionData(rolePermissionsData);
      if (!this.landingModuleId) {
        this.landingModuleId = MODULE_ID.dashboard;
      }
      this.setLandingPage(this.landingModuleId, compInstance);
    } catch (e) { }
  }

  /**
  * Redirect to User specific Landing module
  */
  // setLandingPage(landingModuleId) {
  //   this.menuList.forEach(element => {
  //     if (landingModuleId == element.moduleId) {
  //       this.sessionService.setLocalStorageItem(LOCAL_STORAGE_CONSTANTS.landingPage, element.link);
  //       if (this.sessionService.getSessionItem(SESSION_STORAGE_CONSTANTS.redirectUrl)) {
  //         this.navigationService.navigateByUrl(this.sessionService.getSessionItem(SESSION_STORAGE_CONSTANTS.redirectUrl)).then(() => {
  //           this.spinnerFlag = false;
  //           this.disableButtonFlag = false;
  //         });
  //         this.sessionService.removeSessionItem(SESSION_STORAGE_CONSTANTS.redirectUrl);
  //       } else {
  //         this.navigationService.navigate(element.link).then(() => {
  //           this.spinnerFlag = false;
  //           this.disableButtonFlag = false;
  //         });
  //       }
  //     }
  //   });
  // }

  setLandingPage(landingModuleId, compInstance) {
    this.menuList.forEach(element => {
      if (landingModuleId == element.moduleId) {
        this.navigatoToPage(element, compInstance);
      } else if (element['submenu']) {
        element['submenu'].forEach(subElement => {
          if (landingModuleId == subElement.moduleId) {
            this.navigatoToPage(subElement, compInstance);
          }
        });
      }
    });
  }

  navigatoToPage(element, compInstance) {
    this.sessionService.setLocalStorageItem(LOCAL_STORAGE_CONSTANTS.landingPage, element.link);
    if (this.sessionService.getSessionItem(SESSION_STORAGE_CONSTANTS.redirectUrl)) {
      this.navigationService.navigateByUrl(this.sessionService.getSessionItem(SESSION_STORAGE_CONSTANTS.redirectUrl)).then(() => {
        this.spinnerFlag = false;
        this.disableButtonFlag = false;
        if (compInstance) {
          compInstance.spinnerFlag = false;
          compInstance.disableButtonFlag = false;
        }
      });
      this.sessionService.removeSessionItem(SESSION_STORAGE_CONSTANTS.redirectUrl);
    } else {
      this.navigationService.navigate(ROUTER_LINKS_FULL_PATH['home']).then(() => {
        let element: HTMLElement = document.getElementById('googlebtn') as HTMLElement;
        if (element) {
          element.click();
        }
        this.spinnerFlag = false;
        this.disableButtonFlag = false;
        if (compInstance) {
          compInstance.spinnerFlag = false;
          compInstance.disableButtonFlag = false;
        }
      });
    }
  }


}




// WEBPACK FOOTER //
// ./src/app/shared/role-permission.ts